import { Box, styled } from '@mui/material';

export const MultiResourceContainer = styled(Box)({
  display: 'flex',
  height: '100%'
});

export const CalendarSection = styled(Box, {
  shouldForwardProp: (propName) => propName !== 'fullWidth'
})<{ fullWidth?: boolean }>(({ theme, fullWidth }) => ({
  display: 'flex',
  flex: '1',
  flexDirection: 'column',
  height: '100%',
  maxHeight: `calc(100% - ${theme.custom.constants.MRP.navigationBar.height}px)`,
  padding: `${theme.spacing(4)} 0 ${theme.spacing(4)} ${theme.spacing(4)}`,
  gap: theme.spacing(4),
  overflowY: 'clip',
  maxWidth: fullWidth ? 'calc(100% - 16px)' : 'calc(100% - 660px)'
}));

export const Content = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  height: 'calc(100% - 40px)',
  position: 'relative'
}));
